import { isMobile } from 'utils/detect-environment';
import { User } from 'core/entities';
import { getIsShowSolutionsGuide } from 'features/onboarding/solutions-guide/utils/utils';

export const createElevGroups = (user?: User) => {
    const groups = ['logged-user'];
    if (isMobile()) {
        groups.push('mobile');
    }

    if (user?.settings?.account?.name) {
        Array.prototype.push.call(groups, 'Has-Account', user.settings.account.name);
    }

    return groups;
};

export const _initElev = (_elev: any, user?: User) => {
    const isFreemiumUser = !user?.settings?.account || user.settings?.account?.is_active === false;

    _elev.setUser({
        email: user?.username,
        user_hash: user?.settings?.elevio_email_hash,
        groups: createElevGroups(user),
    });
    _elev.setTranslations({
        modules: {
            support: {
                thankyou: 'Thank you, your feedback is valuable',
                delayed_appearance: ' ',
            },
        },
    });
    _elev.setSettings({
        // hide launcher on mobile | when solutions guide appear
        hideLauncher: isMobile() || getIsShowSolutionsGuide(isFreemiumUser),
    });
};

const initializeElevioScript = () => {
    return new Promise((resolve, reject) => {
        const anyWindow: Window & { _elev: any } = window;

        const elevioPath = 'https://cdn.elev.io/sdk/bootloader/v4/elevio-bootloader.js?cid=';

        if (!anyWindow._elev) {
            anyWindow._elev = {};
        }

        const accountId = process.env.REACT_APP_ELEVIO_ACCOUNT_ID;

        anyWindow._elev.account_id = accountId;

        // check if script already exists
        const isElevioScriptExists = document.querySelectorAll(
            `script[src="${elevioPath}${accountId}"]`,
        )?.length;

        if (!isElevioScriptExists) {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.src = `${elevioPath}${accountId}`;

            script.onerror = reject;
            script.onload = resolve;

            const firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode?.insertBefore(script, firstScriptTag);

            // Initialize the queue for tracking events
            anyWindow._elev.q = [];

            // Define the 'on' method for event tracking
            anyWindow._elev.on = (eventName: string, callback: () => void) => {
                anyWindow._elev.q.push([eventName, callback]);
            };
        } else {
            reject();
        }
    });
};

export const initElevio = async (user: User) => {
    return new Promise<void>((resolve) => {
        initializeElevioScript().catch(() => {
            // We don't want all the application will fail in case Elevio having an issues.
            resolve();
        });

        window._elev.on('load', (_elev) => {
            _initElev(_elev, user);
            resolve();
        });
    });
};
